import { render, staticRenderFns } from "./ClpCustomerPointsReport.vue?vue&type=template&id=7840f3bb&"
import script from "./ClpCustomerPointsReport.vue?vue&type=script&lang=js&"
export * from "./ClpCustomerPointsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports